// Types
import { GetStoreAmas_store } from 'api/ama/types/GetStoreAmas';
// Helpers
import { getStreamerName } from 'helpers/streams';
// Components
import HowAmaWorks from 'components/common3/HowAmaWorks/HowAmaWorks';
import AmaPaymentForm from 'components/common3/AmaPaymentForm/AmaPaymentForm';
import AmaListItem from 'components/common3/AmaList/components/AmaListItem/AmaListItem';

import styles from './OrderAma.module.scss';

type OrderAmaProps = {
  loading: boolean;
  store?: GetStoreAmas_store;
};

const OrderAma = ({ store, loading }: OrderAmaProps) => {
  const ama = store?.amas?.[0];
  const storeName = getStreamerName(store);
  const title = `Ask ${storeName} anything`;
  const daysToResponse = ama?.daysToResponse || 5;

  const amaVideoBlock = (
    <div className={styles.amaVideo}>
      {ama && store && (
        <AmaListItem ama={{ ...ama, store }} type="store" playInModal />
      )}
    </div>
  );

  return (
    <>
      <div className={styles.root}>
        <div>
          <h2 className={styles.title}>{title}</h2>

          <span className={styles.subtitle}>
            Usually responds in {daysToResponse} days
          </span>

          <div className={styles.mobileAmaBlock}>{amaVideoBlock}</div>

          <p className={styles.description}>
            Get a personal video response from me to your questions. I&apos;m
            here to answer questions about my career, training, my journey,
            predictions, or anything you want to know! Hit me up and ask me
            anything!
          </p>

          <HowAmaWorks className={styles.howAmaWorks} openedByDefault={false} />

          {!loading && (
            <AmaPaymentForm
              className={styles.paymentForm}
              paymentRedirectPath={`/${store?.slug}`}
              store={store}
            />
          )}
        </div>

        <div className={styles.desktopAmaBlock}>{amaVideoBlock}</div>
      </div>
    </>
  );
};

export default OrderAma;
